import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const About = () => (
  <Layout>
    <Seo title="About me" />

    <section className="section">
      <div>
        <h2 className="sectionHead rotate">about_</h2>
      </div>
      <div className="sectionContent aboutSection">
        <span>
          <p>
            I want to build a <b>better world</b>, with a better internet.
          </p>
          <p>
            There's a hunger in me not only to learn more about what's possible
            but also to create it. With the fast-paced pace of innovation, it's
            never been more important to keep up with the latest technology. I
            make sure that I can compete with new models coming out every day.
          </p>
          <p style={{ textAlign: "center" }}>
            <q>
              <i>I build things that will make you gasp! </i>
            </q>
          </p>
        </span>
        <div className="aboutmeImage">
          <img
            width="80%"
            src="https://cdn.dribbble.com/users/1510119/screenshots/4630669/media/d2125cddd40563f787dacea3e89d88fc.png?compress=1&resize=400x300"
          />
        </div>
      </div>
    </section>
  </Layout>
)

export default About
